import { CloseIcon } from "components/icons"
import { SearchPopupContent as BaseSearchPopupContent } from "../SearchPopupContent"
import { FilterVenueRadioButtons } from "./FilterVenueRadioButtons"
import { DirectoryOccupantCard } from "components/domains/directory/DirectoryOccupantCard"

export const SearchPopupContent = (props) => {
  const { setVenueFilter, venueFilter, ...restProps } = props
  return (
    <BaseSearchPopupContent
      {...restProps}
      closeIcon={CloseIcon}
      searchResultProps={{
        renderSearchItem: DirectoryOccupantCard,
      }}
      searchBasePopupProps={{
        dialogProps: { disablePortal: true, hideBackdrop: false },
      }}
      searchKeyboardProps={{
        topKeywordAdornment: (
          <FilterVenueRadioButtons
            onChange={setVenueFilter}
            value={venueFilter}
          />
        ),
      }}
    />
  )
}
